<template>
  <div>
    <el-form label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="沟通用户">
            <el-input
              class="cus_width"
              v-model="searchForm.name"
              placeholder="请输入沟通用户"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="沟通途径">
            <el-select
              class="cus_width"
              v-model="searchForm.type"
              clearable
              placeholder="沟通途径"
            >
              <el-option label="电话" :value="0"></el-option>
              <el-option label="微信" :value="1"></el-option>
              <el-option label="售后" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-button @click="getConfig" type="success" :loading="loading"
              >搜索</el-button
            >
            <el-button
              type="primary"
              @click="add(null)"
              >添加
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column align="center" label="沟通用户" prop="name">
      </el-table-column>
      <el-table-column align="center" label="沟通途径" prop="type">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 0">电话 </span>
          <span v-if="scope.row.type == 1">微信</span>
          <span v-if="scope.row.type == 2">售后</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="沟通时间"
        prop="createTime"
      ></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="searchForm.pageNo"
      :page-size="searchForm.pageSize"
      :total="searchForm.total"
    ></el-pagination>
    <el-dialog
      :before-close="handleClose"
      title="新增"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="140px"
      >
        <el-form-item label="用户ID" prop="userId">
          <el-input
            v-model="editForm.userId"
            placeholder="请输入用户ID,非必填"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="沟通途径" prop="type">
          <el-radio-group
            v-model="editForm.type"
            clearable
            placeholder="沟通途径"
            @change="handleTypeChange"
          >
            <el-radio :label="0">电话</el-radio>
            <el-radio :label="1">微信</el-radio>
            <el-radio :label="2">售后</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="editForm.type == 0">
          <el-form-item label="通话时间" prop="time">
            <el-date-picker
              v-model="editForm.time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="通话时长" prop="callDuration">
            <el-input v-model="editForm.callDuration"></el-input>
          </el-form-item>
          <el-form-item label="通话内容摘要" prop="callText">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="editForm.callText"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="客户需求 / 异议" prop="customerRequirements">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="editForm.customerRequirements"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="后续跟进计划" prop="followUpPlan">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="editForm.followUpPlan"
            >
            </el-input>
          </el-form-item>
        </div>
        <div v-if="editForm.type == 1">
          <el-form-item label="沟通时间" prop="time">
            <el-date-picker
              v-model="editForm.time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="沟通内容" prop="contents">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="editForm.contents"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="客户反馈" prop="customerRequirements">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="editForm.customerRequirements"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="是否发送产品资料" prop="isCommodity">
            <el-radio-group
              v-model="editForm.isCommodity"
              clearable
              placeholder="是否发送产品资料"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="附件图片" prop="contentImg">
            <VploadImgFour
              :fileData="fileData"
              :fileSize="fileSize"
              :fileType="fileType"
              :limit="10"
              :value="editForm.contentImg"
              @input="getImgList"
            >
            </VploadImgFour>
          </el-form-item>
        </div>

        <div v-if="editForm.type == 2">
          <el-form-item label="售后订单编号" prop="orderCode">
            <el-input placeholder="请输入内容" v-model="editForm.orderCode">
            </el-input>
          </el-form-item>
          <el-form-item label="问题类型" prop="status">
            <el-radio-group
              v-model="editForm.status"
              clearable
              placeholder="售后问题类型"
            >
              <el-radio :label="0">质量</el-radio>
              <el-radio :label="1">物流</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="反馈时间" prop="time">
            <el-date-picker
              v-model="editForm.time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="处理进度" prop="processingProgress">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="editForm.processingProgress"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="处理结果" prop="processingResult">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="editForm.processingResult"
            >
            </el-input>
          </el-form-item>
        </div>

        <el-form-item style="margin-top: 80px">
          <el-button type="primary" @click="submitForm('editForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      title="详情"
      :visible.sync="dialogVisibleDetails"
      append-to-body
      width="50%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="120px"
      >
        <el-form-item label="用户ID" prop="userId">
          <el-input disabled v-model="editForm.userId"></el-input>
        </el-form-item>
        <el-form-item label="用户名称" prop="name">
          <el-input v-model="editForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="沟通途径" prop="type">
          <el-radio-group
            v-model="editForm.type"
            disabled
            clearable
            @change="handleTypeChange"
          >
            <el-radio :label="0">电话</el-radio>
            <el-radio :label="1">微信</el-radio>
            <el-radio :label="2">售后</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="editForm.type == 0">
          <el-form-item label="通话时间" prop="time">
            <el-date-picker
              v-model="editForm.time"
              type="datetime"
              disabled
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="通话时长" prop="callDuration">
            <el-input v-model="editForm.callDuration" disabled></el-input>
          </el-form-item>
          <el-form-item label="通话内容摘要" prop="callText">
            <el-input
              type="textarea"
              :rows="2"
              disabled
              v-model="editForm.callText"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            label="客户需求 / 异议"
            disabled
            prop="customerRequirements"
          >
            <el-input
              type="textarea"
              :rows="2"
              disabled
              v-model="editForm.customerRequirements"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="后续跟进计划" prop="followUpPlan">
            <el-input
              type="textarea"
              :rows="2"
              disabled
              v-model="editForm.followUpPlan"
            >
            </el-input>
          </el-form-item>
        </div>
        <div v-if="editForm.type == 1">
          <el-form-item label="沟通时间" prop="time">
            <el-date-picker
              v-model="editForm.time"
              disabled
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="沟通内容" prop="contents">
            <el-input
              type="textarea"
              disabled
              :rows="2"
              v-model="editForm.contents"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="客户反馈" prop="customerRequirements">
            <el-input
              type="textarea"
              :rows="2"
              disabled
              v-model="editForm.customerRequirements"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="发送产品资料" prop="isCommodity">
            <el-radio-group v-model="editForm.isCommodity" clearable disabled>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="附件" prop="contentImg">
            <el-image
              v-for="(item, index) in editForm.contentImg.split(',')"
              :key="index"
              style="width: 100px; height: 100px; margin-right: 10px"
              :src="item"
              :preview-src-list="editForm.contentImg.split(',')"
            >
            </el-image>
          </el-form-item>
        </div>

        <div v-if="editForm.type == 2">
          <el-form-item label="售后订单编号" prop="orderCode">
            <el-input disabled v-model="editForm.orderCode"> </el-input>
          </el-form-item>
          <el-form-item label="问题类型" prop="status">
            <el-radio-group v-model="editForm.status" disabled clearable>
              <el-radio :label="0">质量</el-radio>
              <el-radio :label="1">物流</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="反馈时间" prop="time">
            <el-date-picker
              v-model="editForm.time"
              type="datetime"
              disabled
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="处理进度" prop="processingProgress">
            <el-input
              type="textarea"
              :rows="2"
              disabled
              v-model="editForm.processingProgress"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="处理结果" prop="processingResult">
            <el-input
              type="textarea"
              :rows="2"
              disabled
              v-model="editForm.processingResult"
            >
            </el-input>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import TinymceEditor from "../inc/TinymceEditor";
import VploadImgFour from "../inc/VploadImgFour";
export default {
  name: "chatRecord",
  components: {
    TinymceEditor,
    VploadImgFour,
  },
  data() {
    return {
      loading: false,
      fileData: {
        type: 0,
        fileType: 0,
      },
      fileType: ["png", "jpg", "jpeg"],
      fileSize: 5,
      editForm: {},
      tableData: [],
      dialogVisible: false,
      dialogVisibleDetails: false,
      rules: {
        name: [{ required: true, message: "请输入用户名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择沟通途径", trigger: "change" },
        ],
        time: [{ required: true, message: "请选择时间", trigger: "change" }],
        contents: [
          { required: true, message: "请输入沟通内容", trigger: "blur" },
        ],
        customerRequirements: [
          { required: true, message: "请输入客户反馈", trigger: "blur" },
        ],
        followUpPlan: [
          { required: true, message: "请输入跟进计划", trigger: "blur" },
        ],
        callDuration: [
          { required: true, message: "请输入通话时长", trigger: "blur" },
        ],
        callText: [
          { required: true, message: "请输入通话记录", trigger: "blur" },
        ],
        contentImg: [
          { required: true, message: "请上传附件", trigger: "change" },
        ],
        contents: [
          { required: true, message: "请输入沟通内容", trigger: "blur" },
        ],
        isCommodity: [
          {
            required: true,
            message: "请选择是否发送产品资料",
            trigger: "change",
          },
        ],
        name: [{ required: true, message: "请输入用户名称", trigger: "blur" }],
        orderCode: [
          { required: true, message: "请输入订单号", trigger: "blur" },
        ],
        processingProgress: [
          { required: true, message: "请输入处理进度", trigger: "blur" },
        ],
        processingResult: [
          { required: true, message: "请输入处理结果", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择售后问题类型", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择沟通途径", trigger: "change" },
        ],
      },
      goodsVisible: false,
      searchForm: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        type: null,
        status: null,
        name: null,
      },
      goodsList: [],
    };
  },
  created() {
    this.getHomePopList();
  },
  methods: {
    handleTypeChange() {
      this.editForm.time = null;
      this.editForm.callDuration = null;
      this.editForm.callText = null;
      this.editForm.customerRequirements = null;
      this.editForm.followUpPlan = null;
      this.editForm.contents = null;
      this.editForm.isCommodity = null;
      this.editForm.contentImg = "";
      this.editForm.orderCode = null;
      this.editForm.status = null;
      this.editForm.processingProgress = null;
      this.editForm.processingResult = null;
    },
    getImgList(val) {
      console.log(val);
      this.editForm.contentImg = val;
    },
    change(val) {
      this.editForm.describe = val;
    },
    handleDetail(row) {
      this.editForm = {
        ...row,
      };
      this.dialogVisibleDetails = true;
    },
    add() {
      this.editForm = {
        callDuration: null,
        callText: null,
        contentImg: "",
        contents: null,
        customerRequirements: null,
        followUpPlan: null,
        isCommodity: null,
        orderCode: null,
        processingProgress: null,
        processingResult: null,
        status: null,
        time: null,
        type: null,
        userId: null,
      };
      this.dialogVisible = true;
    },
    handleClose() {
      this.$refs["editForm"].resetFields();
      this.dialogVisible = false;
      this.dialogVisibleDetails = false;
    },
    getConfig() {
      this.searchForm.pageNo = 1;
      this.getHomePopList();
    },
    getHomePopList() {
      this.loading = true;
      var obj = {
        pageNo: this.searchForm.pageNo,
        pageSize: this.searchForm.pageSize,
        type: this.searchForm.type,
        status: this.searchForm.status,
        name: this.searchForm.name,
      };
      var filteredObj = {};
      for (var key in obj) {
        if (obj[key] !== null) {
          filteredObj[key] = obj[key];
        }
      }

      this.$axios
        .post("/admin/chatRecord/getList", filteredObj)
        .then((res) => {
          this.tableData = res.data.records || [];
          this.searchForm.total = res.data.total || 0;
        })
        .catch((error) => {
          this.$message({
            message: "获取数据失败：" + (error.message || "未知错误"),
            type: "error",
          });
          this.tableData = [];
          this.searchForm.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.getHomePopList();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.getHomePopList();
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const submitData = JSON.parse(JSON.stringify(this.editForm));
          this.$axios
            .post("/admin/chatRecord/add", submitData)
            .then((res) => {
              this.handleClose();
              this.getHomePopList();
              this.$message({
                message: "恭喜你，操作成功",
                type: "success",
              });
            })
            .catch((error) => {
              this.$message({
                message: "操作失败：" + (error.message || "未知错误"),
                type: "error",
              });
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
